export default "__VITE_ASSET__Cgjlmi5B__"